<template>
    <button class="show-more-btn" :class="{ 'is-opened': isOpened }">
        <svg
            class="show-more-btn__up"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M16.59 16.3594L12 11.7694L7.41 16.3594L6 14.9394L12 8.93938L18 14.9394L16.59 16.3594Z"
                fill="currentColor"
            />
        </svg>
        {{ btnText }}
        <svg
            class="show-more-btn__down"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M7.41 9.08008L12 13.6701L16.59 9.08008L18 10.5001L12 16.5001L6 10.5001L7.41 9.08008Z"
                fill="currentColor"
            />
        </svg>
    </button>
</template>

<script setup lang="ts">
const props = defineProps({
    isOpened: { type: Boolean, default: false },
    showText: { type: String },
    hideText: { type: String },
});

const btnText = computed(() => (props.isOpened ? props.hideText : props.showText));
</script>

<style lang="postcss" scoped>
.show-more-btn {
    @apply inline-flex flex-col md:flex-row items-center text-[#0094FF] font-semibold transition-colors;
    @media (hover: hover) and (pointer: fine) {
        &:hover {
            @apply text-[#0084E3];
        }
    }
    &.is-opened {
        .show-more-btn__up {
            @apply block md:hidden;
        }
        .show-more-btn__down {
            @apply hidden md:block md:rotate-180;
        }
    }
    &__up {
        @apply hidden;
    }
    &__down {
        @apply md:block;
    }
    svg {
        @apply transition-transform;
    }
}
</style>
